import { type Role, isAdminRole } from './IRoleRepository'

export interface UserFormData {
    fullName: string
    email: string
    warehouse?: string
    password?: string
    confirm_password?: string
}

export class UserValidator {
    static validate(
        formData: UserFormData,
        role: Role | undefined,
        mode: 'create' | 'edit'
    ): boolean {
        const {
            fullName,
            email,
            warehouse,
            password = '',
            confirm_password = '',
        } = formData

        // 1. Validaciones básicas de campos obligatorios
        if (fullName.trim() === '' || email.trim() === '' || role === undefined) {
            return false
        }

        // 2. Validación de formato de email
        const emailRegex = /^\S+@\S+\.\S+$/
        if (!emailRegex.test(email)) {
            return false
        }

        // 3. Validación de warehouse si el rol no es de administrador
        const isWarehouseRequired = role && !isAdminRole(role.name)
        if (isWarehouseRequired && (warehouse === undefined || warehouse.trim() === '')) {
            return false
        }

        // 4. Validaciones de contraseña según el modo
        if (mode === 'create') {
            if (password.trim() === '' || password !== confirm_password) {
                return false
            }
        } else {
            // mode === 'edit'
            if (password.trim() !== '' && password !== confirm_password) {
                return false
            }
        }

        return true
    }
}